import { FilterBaseComponent } from "./filter-base-component.js";
import type { SimpleFilter, ColumnData } from "../../types/ListManagerTypes.js";
import { templateParse } from "../../logic/templateParse.js";
import { FILTER_OPERATORS, getOperatorLabel } from "../../constants/FilterConstants.js";

/**
 * Simple filter component for basic text/number/boolean searches
 * Generates SimpleFilter objects for SQL queries like: title ILIKE '%bonus%'
 */
export class FilterSimpleComponent extends FilterBaseComponent {
    static webComponentName: string = "form-simple-filter";
    protected _templateId: string = 'simple-filter';
    // =============================
    // Supported operators for simple filters (from centralized constants)
    // =============================
    private static readonly OPERATORS = FILTER_OPERATORS.simple;

    // =============================
    // Abstract method implementations
    // =============================

    /**
     * Generate SimpleFilter object from current UI state
     */
    generateFilter(): SimpleFilter {
        let searchTerm: any;
        // Handle different operator types
        if (this.operator === 'IS NULL' || this.operator === 'IS NOT NULL') {
            searchTerm = undefined; // NULL operators don't need search term
        } else if (this.operator === 'BETWEEN') {
            // BETWEEN expects array [min, max]
            searchTerm = Array.isArray(this.filterValue) ? this.filterValue : undefined;
        } else {
            // Convert based on filterValueType for proper SQL parameter types
            const valueType = this.colData.filterValueType;
            if (valueType === 'boolean') {
                console.log(`Handle tri-state: undefined means no filter (indeterminate)`, this.filterValue);
                // Handle tri-state: undefined means no filter (indeterminate)
                if (this.filterValue === undefined) {
                    searchTerm = undefined; // No filter applied
                } else {
                    // Convert to actual boolean for PostgreSQL
                    searchTerm = this.filterValue === true || this.filterValue === 'true';
                }
            } else if (valueType === 'number') {
                // Convert to number for PostgreSQL
                searchTerm = Number(this.filterValue) || 0;
            } else {
                // Default to string for text/date/etc
                searchTerm = String(this.filterValue || '');
            }
        }

        return {
            type: 'simple',
            columnName: this.fieldName,
            searchTerm: searchTerm,
            operator: this.operator as SimpleFilter['operator'],
            caseInsensitive: this.operator === 'ILIKE'
        };
    }

    /**
     * Get available operators for simple filters
     */
    getAvailableOperators(): string[] {
        return [...FilterSimpleComponent.OPERATORS];
    }

    /**
     * Validate filter value based on operator
     */
    validateFilterValue(): boolean {
        return true; // Default: accept any non-empty value
    }

    // =============================
    // UI Specialization
    // =============================





    // =============================
    // Debug and development helpers
    // =============================


}

// Component registration handled by index.ts